import { add } from 'date-fns';
import { useCallback, useMemo, useRef, useState } from 'react';

import { useGetPageSize } from '../../../components/InterventionAppointment/hooks/useGetPageSize';

interface UseNavigateCalendarReturn {
  startTime: Date;
  endTime: Date;
  handleNextPage: () => void;
  handlePreviousPage: () => void;
  isFirstPage: boolean;
}

export const useNavigateCalendar = (): UseNavigateCalendarReturn => {
  const pageSize = useGetPageSize();

  const initialStartTimeRef = useRef<Date>(
    add(new Date().setMinutes(0, 0, 0), { days: 0 }),
  );
  const [startTime, setStartTime] = useState<Date>(initialStartTimeRef.current);

  const endTime = useMemo<Date>(() => {
    return add(startTime, { days: pageSize - 1 });
  }, [pageSize, startTime]);

  const handleNextPage = useCallback(() => {
    setStartTime((previousStartTime) =>
      add(previousStartTime, { days: pageSize }),
    );
  }, [pageSize]);

  const handlePreviousPage = useCallback(() => {
    setStartTime((previousStartTime) =>
      add(previousStartTime, { days: -pageSize }),
    );
  }, [pageSize]);

  const isFirstPage =
    startTime.getTime() === initialStartTimeRef.current.getTime();

  return {
    startTime,
    endTime,
    handleNextPage,
    handlePreviousPage,
    isFirstPage,
  };
};
